<template>
  <Dialog :visible="rejectFormShow" :dialogTitle="'拒签'" :width="'450px'" @closeDialog="closeDialog">
    <div slot="dialog" class="rejectFormContaniner">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="form"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="签约密码：" class="elInputCustomer" prop="signPaw">
            <el-input v-model="ruleForm.signPaw" type="password"></el-input>
            <span class="toFindPaw" @click="findPaw">忘记密码</span>
          </el-form-item>
          <el-form-item label="拒签理由：" prop="reason">
            <el-input type="textarea" v-model="ruleForm.reason" rows="3" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="authHandlerBox">
        <div class="button cursorPointer buttonActive submitBtn" @click="submitForm('ruleForm')">提交</div>
      </div>
    </div>
  </Dialog>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
import md5Util from "@lib/encryption.js";
export default {
  props: ["taskId", "contractId"],
  data() {
    return {
      rejectFormShow: true,
      isRequest: false,
      ruleForm: {
        reason: "",
        signPaw: ""
      },
      rules: {
        signPaw: [
          { required: true, message: "请输入签约密码", trigger: "blur" }
        ],
        reason: [
          { required: true, message: "请输入拒签理由", trigger: "blur" },
          { max: 50, message: "拒签理由最多50个字符", trigger: "blur" }
        ]
      }
    };
  },
  components: {
    Dialog
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.rejectFormShow = false;
      this.$emit("closeDialog");
    },
    findPaw() {
      this.$emit("findPaw");
    },
    submitForm(formName) {
      if (!this.isRequest) {
        this.isRequest = true;
        this.$refs[formName].validate(
          valid => {
            if (valid) {
              let locationInfo = this.$store.getters.getLocation;
              BaseApi.createRpcToken(
                "/contract/refuse",
                {
                  id: this.$route.query.id || this.contractId,
                  taskId: this.taskId,
                  reason: this.ruleForm.reason,
                  signPassword: md5Util.md5(this.ruleForm.signPaw),
                  signLocation: locationInfo && locationInfo.location,
                  signLocationAttr: locationInfo && locationInfo.LocationAttr
                },
                "post"
              ).then(
                data => {
                  if (data.datas.success) {
                    this.closeDialog();
                    this.$message.success("拒签成功");
                    this.$emit("restDetail");
                  } else {
                    this.$message.error("拒签失败");
                    this.isRequest = false;
                  }
                },
                () => {
                  this.isRequest = false;
                }
              );
            } else {
              this.isRequest = false;
              return false;
            }
          },
          () => {
            this.isRequest = false;
          }
        );
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.rejectFormContaniner {
  height: 230px;
  display: flex;
  box-sizing: border-box;
  padding: 18px 0 32px 0;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .el-input__inner:focus {
    border-color: #D81212;
    outline: 0;
  }
  .el-textarea__inner:focus {
    border-color: #D81212;
  }
  .form {
    width: 350px;
    margin-bottom: 10px;
    .elInputCustomer {
      .el-form-item__content {
        .el-input {
          width: 170px;
        }
        .toFindPaw {
          margin-left: 15px;
          font-size: 14px;
          color: #969696;
          padding-bottom: 2px;
          border-bottom: 1px solid #969696;
          cursor: pointer;
        }
      }
    }
  }
  .authHandlerBox {
    width: 350px;
  }
  .submitBtn {
    margin-left: 100px;
    width: 250px;
  }
}
</style>
